export const intlPluralRulesLocaleMapping = {
	'de-DE': 'de',
	'en-AU': 'en',
	'en-CA': 'en',
	'en-GB': 'en',
	'en-IN': 'en',
	'en-US': 'en',
	'es-ES': 'es',
	'es-419': 'es',
	'es-AR': 'es',
	'fr-FR': 'fr',
	'hi-IN': 'hi',
	'id-ID': 'id',
	'it-IT': 'it',
	'ja-JP': 'ja',
	'ko-KR': 'ko',
	'pt-BR': 'pt',
	'ru-RU': 'ru',
	'th-TH': 'th',
	'tr-TR': 'tr',
} as const;
